import { combineActions, handleActions } from 'redux-actions';
import { appleSigninSuccess, googleSigninSuccess, signinSuccess } from '../pages/SignIn/actions';
import { setupPhoneNumberSuccess, validateMfaSuccess } from '../components/MfaPanel/actions';
import { cleanupSmsInfo, logoutSuccess, sendSmsVerificationSuccess } from '../actions';
import { validateMfaInputSuccess } from '../pages/MfaInput/actions';
import { SMS_VERIFICATION_TYPE } from '../constants';

/**
 * @type {sms: {[smsType]: [smsSentAt]}
 */
const defaultState = {
  sms: {},
};

export default handleActions(
  {
    [combineActions(
      signinSuccess,
      appleSigninSuccess,
      googleSigninSuccess,
      validateMfaInputSuccess,
    )]: (state, action) => {
      const { user: { smsType, smsSentAt } = {} } = action.response.data || {};
      return {
        ...state,
        sms: smsType
          ? {
              ...state.sms,
              [smsType]: smsSentAt,
            }
          : {},
      };
    },
    [combineActions(setupPhoneNumberSuccess, sendSmsVerificationSuccess)]: (state, action) => {
      const { smsType, smsSentAt } = action.response.data || {};
      return {
        ...state,
        sms: smsType
          ? {
              ...state.sms,
              [smsType]: smsSentAt,
            }
          : {},
      };
    },
    [cleanupSmsInfo]: (state, action) => {
      return {
        ...state,
        sms: { ...state.sms, [action.payload]: null },
      };
    },
    [validateMfaSuccess]: (state) => {
      return {
        ...state,
        sms: { ...state.sms, [SMS_VERIFICATION_TYPE.MFA]: null },
      };
    },
    [logoutSuccess]: () => {
      return defaultState;
    },
  },
  defaultState,
);
